// Generated by purs version 0.13.8
"use strict";
var Data_Nullable = require("/usr/src/app/www/.spago/nullable/v4.1.1/src/Data/Nullable.purs");
var Data_String_Common = require("/usr/src/app/www/.spago/strings/v4.0.2/src/Data/String/Common.purs");
var Foreign = require("/usr/src/app/www/.spago/foreign/v5.0.0/src/Foreign.purs");
var Lib_Components_Bio = require("/usr/src/app/www/src/Lib/Components/Bio.purs");
var Lib_Components_Layout = require("/usr/src/app/www/src/Lib/Components/Layout.purs");
var Lib_Components_Seo = require("/usr/src/app/www/src/Lib/Components/SEO.purs");
var Lib_Packages_Gatsby_Link = require("/usr/src/app/www/src/Lib/Packages/Gatsby/Link.purs");
var Lib_Utils_Typography = require("/usr/src/app/www/src/Lib/Utils/Typography.purs");
var React_Basic_DOM = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM.purs");
var React_Basic_DOM_Generated = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Generated.purs");
var React_Basic_DOM_Internal = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Internal.purs");
var blogPost = function (props) {
    var site = function (props1) {
        return {
            siteMetaData: {
                author: props1.data.site.siteMetaData.author,
                social: props1.data.site.siteMetaData.social
            }
        };
    };
    var bioComponent = function (avatar) {
        return function (site1) {
            return Lib_Components_Bio.bio({
                avatar: avatar,
                site: site1
            });
        };
    };
    return Lib_Components_Layout.layout({
        year: "2020",
        location: props.location,
        title: props.data.site.siteMetadata.title,
        children: [ Lib_Components_Seo.seo({
            title: Data_Nullable.notNull(props.data.markdownRemark.frontmatter.title),
            metaDescription: (function () {
                var $0 = Data_String_Common["null"](props.data.markdownRemark.frontmatter.description);
                if ($0) {
                    return Data_Nullable.notNull(props.data.markdownRemark.frontmatter.description);
                };
                return Data_Nullable.notNull(props.data.markdownRemark.excerpt);
            })(),
            meta: Data_Nullable["null"],
            lang: Data_Nullable["null"],
            author: Data_Nullable["null"]
        }), React_Basic_DOM_Generated.article_([ React_Basic_DOM_Generated.header_([ React_Basic_DOM_Generated.h1()({
            style: React_Basic_DOM_Internal.css({
                marginTop: Lib_Utils_Typography.rhythm(1.0),
                marginBottom: 0.0
            }),
            children: [ React_Basic_DOM.text(props.data.markdownRemark.frontmatter.title) ]
        }) ]), React_Basic_DOM_Generated.p()({
            style: React_Basic_DOM_Internal.css({
                fontSize: (Lib_Utils_Typography.scale(-1.0 / 5.0)).fontSize,
                lineHeight: (Lib_Utils_Typography.scale(-1.0 / 5.0)).lineHeight,
                display: "block",
                marginBottom: Lib_Utils_Typography.rhythm(1.0)
            }),
            children: [ React_Basic_DOM.text(props.data.markdownRemark.frontmatter.date) ]
        }), React_Basic_DOM_Generated.section()({
            dangerouslySetInnerHTML: {
                "__html": props.data.markdownRemark.html
            }
        }), React_Basic_DOM_Generated.hr()({
            style: React_Basic_DOM_Internal.css({
                marginBottom: Lib_Utils_Typography.rhythm(1.0)
            })
        }), React_Basic_DOM_Generated.footer_([ bioComponent(props.data.avatar)(props.data.site) ]) ]), React_Basic_DOM_Generated.nav_([ React_Basic_DOM_Generated.ul()({
            style: React_Basic_DOM_Internal.css({
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                listStyle: "none",
                padding: 0
            }),
            children: (function () {
                var $1 = !Foreign.isNull(Foreign.unsafeToForeign(props.pageContext.previous)) && !Foreign.isNull(Foreign.unsafeToForeign(props.pageContext.next));
                if ($1) {
                    return [ React_Basic_DOM_Generated.li_([ Lib_Packages_Gatsby_Link.link({
                        to: props.pageContext.previous.fields.slug,
                        rel: "prev",
                        children: [ React_Basic_DOM.text("\u2190 " + props.pageContext.previous.frontmatter.title) ]
                    }) ]), React_Basic_DOM_Generated.li_([ Lib_Packages_Gatsby_Link.link({
                        to: props.pageContext.next.fields.slug,
                        rel: "next",
                        children: [ React_Basic_DOM.text(props.pageContext.next.frontmatter.title + " \u2192") ]
                    }) ]) ];
                };
                var $2 = !Foreign.isNull(Foreign.unsafeToForeign(props.pageContext.previous));
                if ($2) {
                    return [ React_Basic_DOM_Generated.li_([ Lib_Packages_Gatsby_Link.link({
                        to: props.pageContext.previous.fields.slug,
                        rel: "prev",
                        children: [ React_Basic_DOM.text("\u2190 " + props.pageContext.previous.frontmatter.title) ]
                    }) ]) ];
                };
                var $3 = !Foreign.isNull(Foreign.unsafeToForeign(props.pageContext.next));
                if ($3) {
                    return [ React_Basic_DOM_Generated.li_([ Lib_Packages_Gatsby_Link.link({
                        to: props.pageContext.next.fields.slug,
                        rel: "next",
                        children: [ React_Basic_DOM.text(props.pageContext.next.frontmatter.title + " \u2192") ]
                    }) ]) ];
                };
                return [  ];
            })()
        }) ]) ]
    });
};
module.exports = {
    blogPost: blogPost
};

